import React, { useState } from "react";
import {
  TableBody,
  TableCell,
  TableRow,
  Modal,
  ModalBody,
} from "@windmill/react-ui";

import { FiCopy, FiEye } from "react-icons/fi";

import DeleteModal from "components/modal/DeleteModal";
import RemarkModal from "components/modal/RemarkModal";
import VendorRemarks from "components/modal/VedorRemarks";
import ViewModal from "components/modal/ViewVendorModal";
import VendorRateSheetViewModal from "components/modal/VendorRateSheetViewModal";

import useToggleDrawer from "hooks/useToggleDrawer";
import { notifyError, notifySuccess } from "utils/toast";

const VendorRatesSubmittedTable = ({
  VendorRatesData = [],
  perpage,
  currentPage,
}) => {

  const BASE_URL = process.env.REACT_APP_VENDOR_RATE_LINK;

  const {
    title,
    serviceId,
    serviceBlock,
  } = useToggleDrawer();

  const [isOpen, setIsOpen] = useState(false);

  const [openRemarks, setOpenRemarks] = useState(false);

  const [selectedData, setSelectedData] =
    useState(null);

  const [viewRateModal, setViewRateModal] =
    useState(false);

  const [selectedRateSheet, setSelectedRateSheet] =
    useState(null);

  const handleSuccessModalClose = () => {
    setIsOpen(false);
  };

  const handleViewRateSheet = (row) => {
    setSelectedRateSheet(row);
    setViewRateModal(true);
  };

  const handleCopyLink = async (link) => {
    try {
      const fullLink = `${BASE_URL}${link}`;

      console.log(fullLink, 'here si the kkkjjkj full link')

      await navigator.clipboard.writeText(fullLink);

      notifySuccess("Link copied successfully");
    } catch (err) {
      notifyError("Failed to copy link");
    }
  };


  return (
    <>
      {/* <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      />

      <VendorRemarks
        isOpen={openRemarks}
        selectedData={selectedData}
        onClose={() => setOpenRemarks(false)}
      />

      <DeleteModal
        id={serviceId}
        title={title}
      />

      <ViewModal
        id={serviceId}
        title={title}
        data={VendorRatesData}
      /> */}

      <VendorRateSheetViewModal
        isOpen={viewRateModal}
        onClose={() => {
          setViewRateModal(false);
          setSelectedRateSheet(null);
        }}
        ratesheet={selectedRateSheet}
      />

      <TableBody>

        {VendorRatesData
          ?.slice(0, perpage)
          ?.map((row, index) => (

            <TableRow key={row.id}>

              <TableCell className="text-center text-sm">
                {(currentPage - 1) * perpage +
                  index +
                  1}
              </TableCell>

              <TableCell className="text-center text-sm font-medium">
                <div className="flex items-center flex-col">
                  <span>{row.vendor_name}</span>
                  <span className="text-gray-400">{row.phone_number}</span>
                </div>
              </TableCell>

              <TableCell className="text-center text-sm">
                <div className="flex items-center flex-col">
                  <span>{row.city_name}</span>
                  <span className="text-gray-400">{row.state_name}</span>
                </div>
              </TableCell>

              {/* <TableCell className="text-center text-sm">
                {row.phone_number}
              </TableCell> */}

              <TableCell className="text-center text-sm">
                <div className="flex items-center flex-col">
                  <span>{row.form_submit_date}</span>
                  <span className="text-gray-400">{row.form_submit_time}</span>
                </div>
              </TableCell>

              <TableCell className="text-center text-sm">
                <button
                  type="button"
                  onClick={() => handleCopyLink(row.link)}
                  className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-green-600 text-white hover:bg-green-700"
                >
                  <FiCopy size={15} />
                  Copy Link
                </button>
              </TableCell>

              {/* <TableCell className="text-center text-sm">
                {row.form_submit_time}
              </TableCell> */}

              <TableCell className="text-center">

                {row.link_status === 1 ? (
                  <span className="px-3 py-1 rounded-full bg-green-100 text-green-700 text-xs font-semibold">
                    Submitted
                  </span>
                ) : (
                  <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs font-semibold">
                    Unsubmitted
                  </span>
                )}

              </TableCell>

              <TableCell>

                <div className="flex justify-center">

                  {row.link_status === 1 ? <button
                    onClick={() =>
                      handleViewRateSheet(row)
                    }
                    className="p-2 rounded-lg text-gray-500 hover:bg-green-100 hover:text-green-700 transition-all duration-200"
                  >
                    <FiEye size={18} />
                  </button> : "-"}

                </div>

              </TableCell>

            </TableRow>

          ))}

      </TableBody>

      <Modal
        isOpen={isOpen}
        onClose={handleSuccessModalClose}
      >
        <div className="flex justify-between items-center p-4 border-b">

          <h2 className="text-lg font-semibold">
            Success
          </h2>

          <button
            onClick={handleSuccessModalClose}
            className="text-gray-500 hover:text-red-500"
          >
            ✕
          </button>

        </div>

        <ModalBody>
          Vendor Added Successfully
        </ModalBody>

      </Modal>
    </>
  );
};

export default VendorRatesSubmittedTable;